export const apiDomainOnly = "https://api.recentair.com";
// export const apiDomainOnly = "http://192.168.1.67:8000";
export const apiDomain = `${apiDomainOnly}/api/`;

// export const apiDomain = apiDomainOnly + "/api/"
export const grafanaDomain = "https://grafana.recentair.com/";